
<template>
  <yxt-drawer
    v-drawerloading="loading"
    :title="titleInternalKey?$t(titleInternalKey):title"
    :before-close="cancelHandle"
    :visible.sync="visible"
    direction="rtl"
    :size="parseInt(size)>parseInt(maxWidth)?maxWidth:size"
  >
    <yxt-empty :empty-text='warnMsg' />
    <div slot="footer">
      <yxt-button plain @click="cancelHandle">{{ $t('pc_ulcd_btn_cancel') }}</yxt-button>
    </div>
  </yxt-drawer>
</template>

<script>

export default {

  props: {
    visible: { type: Boolean, default: false }, // 业务组件抽屉是否显示
    titleInternalKey: { type: String, default: '' }, // 对应2.0平台中业务组件模块下的国际化key
    maxWidth: { type: String, default: ' 960px' },
    taskVersion: { type: String, default: '' },
    loading: { type: Boolean, default: false }
  },
  data() {
    return {

    };
  },
  computed: {
    warnMsg() {
      return `当前版本：${this.taskVersion}不存在`;
    }
  },
  methods: {
    cancelHandle() { // 业务数据，可为null
      this.$emit('cancelHandle', {});
    }
  }
};
</script>
